import React, { useContext, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { menuInboxBadgeCounterVar } from 'graphql/cache';

import { useMessageContext } from 'utils/context/MessagesContext';
import {
  GetMeccaConversationsPreviewQueryVariables,
  useGetMeccaConversationsPreviewLazyQuery,
} from '../../../models/graphql';
import { InboxContext } from '../../../utils/context/InboxContext/inbox.context';
import { useAuth } from '../../../auth/AuthProvider';
import './CustomMenuBadge.scss';

export interface ICustomMenuBadgeProps {
  pageName: keyof typeof menuInboxBadgeCounterVar;
}

const CustomMenuBadge: React.FC<ICustomMenuBadgeProps> = ({ pageName }) => {
  const { shouldRefetchInbox } = useContext(InboxContext);
  const { isAuthenticated } = useAuth();
  const [getMeccaConversations, { data: meccaConversations }] =
    useGetMeccaConversationsPreviewLazyQuery();
  const callCenterCount = useReactiveVar(menuInboxBadgeCounterVar.callCenter);

  const callCenterVariables = React.useMemo<GetMeccaConversationsPreviewQueryVariables>(() => {
    return {
      filter: {
        read: false,
      },
    };
  }, []);

  const { setMessageCount } = useMessageContext();

  useEffect(() => {
    if (pageName === 'callCenter' && isAuthenticated) {
      getMeccaConversations({ variables: callCenterVariables });
    }
  }, [pageName, shouldRefetchInbox, callCenterVariables, getMeccaConversations, isAuthenticated]);

  useEffect(() => {
    const unreadCallCenterCount =
      meccaConversations?.meccaConversations?.count.toString() || callCenterCount;
    menuInboxBadgeCounterVar.callCenter(unreadCallCenterCount);
    setMessageCount(+unreadCallCenterCount || 0);
  }, [callCenterCount, meccaConversations, setMessageCount]);

  return (
    <div className="custom-badge">
      <span>{callCenterCount}</span>
    </div>
  );
};

export default CustomMenuBadge;
